<div role="tablist" class="aa-wizard">
    <div class="aa-all-steps">
        <ng-container *ngFor="let step of steps; index as idx; last as isLast">
            <div class="aa-step" [class.active]="step.active" [class.disabled]="step.disabled" [class.deactivated]="step.deactivated">
                <div
                    [style.height.px]="height"
                    class="aa-step-title"
                    (click)="activateStep(idx)"
                >
                    <div *ngIf="!isLast" class="step">
                        <div class="step-text">
                        {{ 'WIZARD.STEPS.NAME' | translate }}&nbsp;{{ idx + 1 }}
                        </div>
                        <aa-icon-circle class="blue duotone" [faIcon]="'fal fa-check'" *ngIf="step.valid"></aa-icon-circle>
                    </div>
                    <div *ngIf="isLast" class="step">
                        &nbsp;
                    </div>
                    <div class="title">
                        {{ step.title }}
                        <ng-template
                            [ngTemplateOutlet]="step.titleTpl?.templateRef"
                        ></ng-template>
                    </div>
                </div>
                <div class="aa-step-border"></div>
            </div>
        </ng-container>
    </div>
    <div class="aa-next-step">
        <div class="aa-step" [class.disabled]="nextDisabled">
            <div [style.height.px]="height" class="aa-step-title" (click)="clickNextStep()">
                <div class="step">&nbsp;</div>
                <div class="title">
                    {{'WIZARD.BUTTONS.NEXT' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
<div class="aa-step-content">
    <ng-container *ngFor="let step of steps">
        <div
            role="tabpanel"
            [attr.aria-labelledby]="step.id"
            id="{{ step.id }}-panel"
            *ngIf="step.active"
        >
            <ng-template
                [ngTemplateOutlet]="step.contentTpl?.templateRef"
            ></ng-template>
        </div>
    </ng-container>
</div>
